import React from 'react'
import classNames from 'classnames'

export default function Radio({
  disabled,
  value,
  checked,
  children,
  onChange,
}) {
  return (
    <label
      className={classNames(
        'flexbox flexbox-align-center margin-bottom-medium',
        { pointer: !disabled, 'cursor-forbidden': disabled }
      )}
    >
      <div
        className="pointer margin-right-medium border-medium border-shade-30"
        style={{
          width: 16,
          height: 16,
          padding: 1,
          borderRadius: '50%',
          borderWidth: '2px',
        }}
      >
        <input
          type="radio"
          className={`pointer ${
            checked ? 'background-primary' : 'background-shade-100'
          }`}
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            verticalAlign: 'top',
          }}
          disabled={disabled}
          value={value}
          checked={checked}
          onChange={onChange}
        />
      </div>
      <div
        className={classNames('line-height-large', {
          'shade-20': !disabled,
          'shade-30': disabled,
        })}
      >
        {children}
      </div>
    </label>
  )
}
